document.addEventListener('DOMContentLoaded', function() {
    // Initialize intl-tel-input for phone number field with India as the initial country
    const phoneInputField = document.querySelector("#phoneNumber");
    const iti = window.intlTelInput(phoneInputField, {
        initialCountry: "in",
        utilsScript: intlTelUtils,
        formatOnDisplay: false,
        nationalMode: false,
        separateDialCode: true,
        autoHideDialCode: true,
        hiddenInput: "full_phone"
    });

    // Add CSS to fix spacing
    const style = document.createElement('style');
    style.textContent = `
        .iti__flag-container {
            right: auto;
            left: 0;
        }
        .iti--separate-dial-code .iti__selected-flag {
            padding-right: 6px !important;
        }
        .iti--separate-dial-code input {
            padding-left: 52px !important;
        }
        input#phoneNumber {
            letter-spacing: 1px;
        }
    `;
    document.head.appendChild(style);

    // Function to format phone number with spaces
    function formatPhoneNumber(value) {
        const cleaned = value.replace(/\D/g, '');
        const formatted = cleaned.replace(/(\d{5})(?=\d)/g, '$1 ');
        return formatted;
    }

    // Add input event listener for phone number formatting
    phoneInputField.addEventListener('input', function(e) {
        let value = this.value;
        value = value.replace(/^0+/, '');
        const formattedNumber = formatPhoneNumber(value);
        this.value = formattedNumber;
    });

    // Retrieve values from sessionStorage
    const orderId = sessionStorage.getItem('orderId');
    const phoneNumber = sessionStorage.getItem('phoneNumber');

    // Set order ID if it exists in session storage
    if (orderId) {
        document.getElementById('orderName').value = orderId;
    }

    // Set phone number if it exists in session storage
    if (phoneNumber) {
        const formattedPhone = formatPhoneNumber(phoneNumber.replace(/^0+/, '').replace(/\D/g, ''));
        phoneInputField.value = formattedPhone;
    }

    // Remove the selected dial code from display
    const dialCodeSpan = document.querySelector('.iti__selected-dial-code');
    if (dialCodeSpan) {
        dialCodeSpan.style.display = 'none';
    }

    // Clear session storage after retrieving values
    sessionStorage.removeItem('orderId');
    sessionStorage.removeItem('phoneNumber');

    // Add an element to display error messages above the search button
    const searchButton = document.getElementById('searchButton');
    const errorMessageElement = document.createElement('div');
    errorMessageElement.id = 'errorMessage';
    errorMessageElement.style.color = 'red';
    errorMessageElement.style.marginBottom = '10px';

    // Insert the error message element before the search button
    searchButton.parentNode.insertBefore(errorMessageElement, searchButton);

    // Add a loader element inside the submit button
    const loader = document.createElement('span');
    loader.className = 'loader';
    loader.style.display = 'none';
    searchButton.appendChild(loader);

    // Handle form submission
    document.getElementById('searchForm').addEventListener('submit', function(e) {
        e.preventDefault();

        // Clear any previous error messages
        errorMessageElement.textContent = '';

        // Get the order name and phone number
        const orderName = document.getElementById('orderName').value;
        const phoneNumber = phoneInputField.value.replace(/\s/g, '');
        const countryCode = iti.getSelectedCountryData().dialCode;

        // Validate order name
        if (!orderName) {
            errorMessageElement.textContent = "Please enter the order number.";
            return;
        }

        // Validate phone number is not empty after cleaning
        if (!phoneNumber) {
            errorMessageElement.textContent = "Please enter a valid phone number.";
            return;
        }

        // Disable the submit button and show the loader
        searchButton.disabled = true;
        loader.style.display = 'inline-block';
        console.log('Loader is now visible, and the submit button is disabled.');

        // Concatenate country code and cleaned phone number
        const fullPhoneNumber = `+${countryCode}${phoneNumber}`;
        console.log('Full phone number:', fullPhoneNumber);
        
        // Prepare the request body
        const formdata = new FormData();
        formdata.append("order_name", orderName);
        formdata.append("phone", fullPhoneNumber);

        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow"
        };

        fetch("https://manicthemes.com/wearcomet-order-tracking/", requestOptions)
            // .then((response) => response.json())
          .then((response) => {
              console.log("Raw Response:", response);
              return response.json();
          })
            .then((result) => {
              console.log("Server message:", result.message);
              console.log("Parsed Response:", result);
                if (result.status) {
                  console.log("Data Field:", result.data);
                    if (result.data && result.data.message && result.data.message.waybillDetails && result.data.message.waybillDetails[0]) {
                        displayResponse(result.data.message.waybillDetails[0]);
                    } else {
                        console.error('Invalid data format:', result);
                        errorMessageElement.textContent = 'Invalid data format received from the server.';
                    }
                } else {
                    console.error('Error:', result.message);
                    if (result.message === "Tracking number Not Found") {
                        displayOrderPlacedRecently();
                    } else {
                        errorMessageElement.textContent = result.message;
                    }
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                errorMessageElement.textContent = error.message;
            })
            .finally(() => {
                // Re-enable the submit button and hide the loader
                searchButton.disabled = false;
                loader.style.display = 'none';
                console.log('Loader is hidden, and the submit button is re-enabled.');
            });
    });

    // Function to display the response
    function displayResponse(data) {
        const activityTimeline = document.getElementById('activityTimeline');
        const orderPlacedTitle = document.getElementById('orderPlacedTitle');
        const trackinId = document.getElementById('trackinId');
        const estimatedDate = document.getElementById('estimatedDate');

        if (!data || !activityTimeline || !orderPlacedTitle || !trackinId || !estimatedDate) {
            console.error('Required elements or data are missing.');
            return;
        }

        // Sort the events by timestamp in descending order
        const sortedHistory = data.order_history.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        const finalHistory = sortedHistory[0];

        // Set the title based on the tracking ID status
        if (!data.waybill) {
            orderPlacedTitle.textContent = 'Order Placed Recently';
        } else {
            orderPlacedTitle.textContent = finalHistory.orderStatusDescription;
        }

        // Display the final history status
        trackinId.textContent = `Tracking: ${data.waybill ? data.waybill : '-'}`;
        estimatedDate.textContent = `Estimated Delivery: ${data.edd ? formatDate(data.edd) : '-'}`;

        // Display the sorted activity timeline
        activityTimeline.innerHTML = sortedHistory.map(history => {
            const formattedTime = new Date(history.timestamp).toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });

            return `
            <div class="event" style="border-left-color: yellow;">
              <div class="activity">Activity: ${history.orderStatusDescription}</div>
              <div class="time">${formattedTime}</div>
            </div>
          `;
        }).join('');

        showModal();
    }

    // Function to handle "Order Placed Recently" status
    function displayOrderPlacedRecently() {
        const orderPlacedTitle = document.getElementById('orderPlacedTitle');
        const trackinId = document.getElementById('trackinId');
        const estimatedDate = document.getElementById('estimatedDate');
        const activityTimeline = document.getElementById('activityTimeline');

        if (!orderPlacedTitle || !trackinId || !estimatedDate || !activityTimeline) {
            console.error('Required elements not found in the modal.');
            return;
        }

        orderPlacedTitle.textContent = 'Order Placed Recently';
        trackinId.textContent = 'Tracking: Order being processed';
        estimatedDate.textContent = 'Estimated Delivery: Order being processed';
        activityTimeline.innerHTML = '<div class="event"><div class="activity">Order placed.</div></div>';

        showModal();
    }

    // Function to format date
    function formatDate(date) {
        const options = {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        };
        return new Date(date).toLocaleDateString('en-US', options);
    }

    // Function to show modal
    function showModal() {
        const modal = document.getElementById('responseModal');
        if (modal) {
            modal.style.display = 'flex';
        } else {
            console.error('Modal element not found.');
        }
    }

    // Handle modal close functionality
    const modal = document.getElementById('responseModal');
    const closeButton = document.querySelector('.close');

    function closeModal() {
        if (modal) {
            modal.style.display = 'none';
        } else {
            console.error('Modal element not found.');
        }
    }

    if (closeButton) {
        closeButton.addEventListener('click', function() {
            closeModal();
        });
    }

    // Add event listener to close modal when clicking outside
    window.addEventListener('click', function(event) {
        if (modal && event.target === modal) {
            closeModal();
        }
    });
});